import * as React from 'react'
import { locationSearchColumns } from './locationSearchColumns'
import {
  ServiceLocation,
  useSearchServiceLocations,
} from '@user/store/entityLocations'

import {
  GridColDef,
  GridPaginationModel,
  DataGridPro as XGrid,
} from '@mui/x-data-grid-pro'
import Button from '@mui/material/Button'

type LocationsTableProps = {
  branchesLoading: boolean
  onClickCreateOpp: (billTo: ServiceLocation) => void
  searchState: ReturnType<typeof useSearchServiceLocations>
}

export const LocationsTable: React.FC<LocationsTableProps> = (props) => {
  const { branchesLoading, onClickCreateOpp, searchState } = props

  const {
    items,
    count,
    loading: resultsLoading,
    page,
    onChangePage,
    take,
  } = searchState

  const columns = React.useMemo(() => {
    const createButton: GridColDef = {
      field: 'createButton',
      headerName: ' ',
      width: 150,
      sortable: false,
      resizable: false,
      renderCell: ({ row }) => (
        <Button
          data-test-id={`createOppBtn-${row.id}`}
          onClick={() => onClickCreateOpp(row as ServiceLocation)}
          color="primary"
          variant="outlined"
        >
          Create Opportunity
        </Button>
      ),
    }

    return [createButton, ...locationSearchColumns]
  }, [onClickCreateOpp])

  const handlePaginationModelChange = React.useCallback(
    (pageModel: GridPaginationModel) => onChangePage({}, pageModel.page + 1),
    [onChangePage],
  )

  const loading = resultsLoading || branchesLoading
  const rows = branchesLoading ? [] : items

  return (
    <XGrid
      columns={columns}
      disableColumnMenu
      disableRowSelectionOnClick
      loading={loading}
      rows={rows}
      rowCount={count}
      pagination
      paginationModel={{ page: page - 1, pageSize: take }}
      paginationMode="server"
      pageSizeOptions={[take]}
      onPaginationModelChange={(paginationModel) =>
        handlePaginationModelChange(paginationModel)
      }
    />
  )
}
LocationsTable.displayName = 'LocationsTable'
